var pagination = {
	backwardText: "vorherige Seite",
	forwardText: "nächste Seite",
	pageRangeText: "Seite {current} von {total}",
	itemsPerPageText: "Einträge pro Seite",
	itemRangeText: "{start}-{end} von {total} Elementen",
	pageNumberText: "aktuelle Seite"
};
var searchPlaceholder = "Suchen...";
var deTranslations = {
	pagination: pagination,
	searchPlaceholder: searchPlaceholder
};

export { deTranslations as default, pagination, searchPlaceholder };
